/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

"use strict";

exports["default"] = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

exports.__esModule = true;



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/helpers/class-call-check.js
 ** module id = 30
 ** module chunks = 0
 **/